import React, { useCallback } from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { BaseCellProps } from ".";
import styles from "./RowNumberCell.module.scss";

enum Action {
    RemoveRow = 1,
    InsertRowAbove = 2,
    InsertRowBelow = 3,
}

const items: Array<PickerItemData<Action>> = [
    { label: "Remove row", value: Action.RemoveRow },
    { label: "Insert row above", value: Action.InsertRowAbove },
    { label: "Insert row below", value: Action.InsertRowBelow },
];

export const RowNumberCell: React.FC<BaseCellProps> = ({
    isEditing,
    rowIdx,
    removeRow,
    addRow,
    finishEditing,
}) => {
    const handleSelect = useCallback(
        (value: Action) => {
            if (value === Action.RemoveRow) {
                removeRow(rowIdx);
            }

            if (value === Action.InsertRowAbove) {
                addRow(rowIdx);
            }

            if (value === Action.InsertRowBelow) {
                addRow(rowIdx + 1);
            }
        },
        [removeRow, addRow, rowIdx],
    );

    if (isEditing) {
        return (
            <>
                <div
                    className={styles.dropdownCellEditor}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                >
                    <Picker.Select
                        items={items}
                        value={null}
                        defaultOpen
                        chevron="none"
                        trigger={
                            <Picker.Button
                                variant="primary"
                                size="sm"
                                block
                                className={styles.dropdownTrigger}
                            />
                        }
                        onValueChange={(value) => {
                            if (value != null) {
                                handleSelect(value);
                            }
                        }}
                        onOpenChange={(open) => {
                            if (!open) {
                                finishEditing();
                            }
                        }}
                    />
                </div>
                <div className={styles.rowNumberCell}>{rowIdx + 1}</div>
            </>
        );
    }

    return <div className={styles.rowNumberCell}>{rowIdx + 1}</div>;
};
